import React, { Component } from "react";
import * as Icon from "react-feather";

const EMAIL_RE = /^[^\s<>@]+@[^\s<>@]+\.[^\s<>@]+$/;

class RecipientField extends Component {
	constructor(props) {
		super(props);
		this.state = { input: "" };
		this.inputRef = React.createRef();
	}

	focus = () => {
		if (this.inputRef.current) this.inputRef.current.focus();
	};

	commit = raw => {
		const value = (raw || "").trim().replace(/,$/, "").trim();
		if (!value) return false;
		const { recipients = [], onChange } = this.props;
		if (recipients.includes(value)) {
			this.setState({ input: "" });
			return true;
		}
		const next = recipients.concat(value);
		onChange && onChange(next);
		this.setState({ input: "" });
		return true;
	};

	onChange = e => {
		const v = e.target.value;
		if (v.endsWith(",") || v.endsWith(";")) {
			this.commit(v.slice(0, -1));
		} else {
			this.setState({ input: v });
		}
	};

	onKeyDown = e => {
		const { input } = this.state;
		const { recipients = [], onChange } = this.props;
		if ((e.key === "Enter" || e.key === "Tab") && input.trim()) {
			e.preventDefault();
			this.commit(input);
		} else if (e.key === "Backspace" && input === "" && recipients.length > 0) {
			onChange && onChange(recipients.slice(0, -1));
		}
	};

	onBlur = () => {
		if (this.state.input.trim()) this.commit(this.state.input);
	};

	remove = idx => {
		const { recipients = [], onChange } = this.props;
		onChange && onChange(recipients.filter((_, i) => i !== idx));
	};

	render() {
		const { label, recipients = [], placeholder, rightSlot } = this.props;
		const { input } = this.state;
		return (
			<div className="recipient-row">
				<label className="recipient-row__label">{label}</label>
				<div className="recipient-row__input-wrap" onClick={this.focus}>
					{recipients.map((r, i) => {
						const valid = EMAIL_RE.test(r);
						return (
							<span key={i} className={`recipient-chip${valid ? "" : " is-invalid"}`} title={r}>
								<span className="recipient-chip__text">{r}</span>
								<button type="button" className="recipient-chip__x" onClick={() => this.remove(i)}>
									<Icon.X size={11} />
								</button>
							</span>
						);
					})}
					<input
						ref={this.inputRef}
						className="recipient-row__input"
						type="text"
						value={input}
						onChange={this.onChange}
						onKeyDown={this.onKeyDown}
						onBlur={this.onBlur}
						placeholder={recipients.length === 0 ? placeholder || "" : ""}
					/>
				</div>
				{rightSlot && <div className="recipient-row__right">{rightSlot}</div>}
			</div>
		);
	}
}

export default RecipientField;
